import React from 'react';
import Loadingif from '../Images/loadingSpinner.gif';

const Loading = () => {
    return (
        <div className='flex items-center justify-center h-screen'>
            <img src={Loadingif} className="w-20 h-20" alt="Loading.." />
        </div>
    );
};

export default Loading;